import type { LocalizedDict } from '../index'

export type NewSampleRequestStrings = {
  title: string
  subtitle: string
  close: string
  sampleName: string
  sampleNamePlaceholder: string
  etsyUrl: string
  fetch: string
  photosAttached: (n: number) => string
  previewUnavailable: (error: string) => string
  cancel: string
  creating: string
  create: string
}

export const newSampleRequestI18n: LocalizedDict<NewSampleRequestStrings> = {
  en: {
    title: 'New sample request',
    subtitle: 'Name it, optionally paste an Etsy listing to pull a reference.',
    close: 'Close',
    sampleName: 'Sample name *',
    sampleNamePlaceholder: 'Reversible scarf headband',
    etsyUrl: 'Etsy listing URL (optional)',
    fetch: 'Fetch',
    photosAttached: (n) => `${n} photo(s) attached`,
    previewUnavailable: (error) => `Preview unavailable (${error}); you can still create.`,
    cancel: 'Cancel',
    creating: 'Creating…',
    create: 'Create',
  },
  tr: {
    title: 'Yeni numune talebi',
    subtitle: 'Bir ad ver; istersen referans almak için bir Etsy ilanı yapıştır.',
    close: 'Kapat',
    sampleName: 'Numune adı *',
    sampleNamePlaceholder: 'Çift taraflı eşarp saç bandı',
    etsyUrl: 'Etsy ilan bağlantısı (isteğe bağlı)',
    fetch: 'Getir',
    photosAttached: (n) => `${n} fotoğraf eklendi`,
    previewUnavailable: (error) => `Önizleme alınamadı (${error}); yine de oluşturabilirsin.`,
    cancel: 'Vazgeç',
    creating: 'Oluşturuluyor…',
    create: 'Oluştur',
  },
}
